import flattenApplicationFields from './flattenApplicationFields';
import getApplicationFields from './getApplicationFields';
/**
 * Returns a flat array of only application fields that take a value
 * @param {object} ion - An ION Instance
 * @param {boolean} [getHiddenFields=false] - A boolean that determines whether or not hidden fields are returned.
 * @returns {import('../model').Field[]} An flattened array of fields
 * @memberof module:ionHelpers
 */
const getFields = (ion, getHiddenFields = false) => {
    if (getHiddenFields) {
        return flattenApplicationFields(getApplicationFields(ion));
    }
    // using explicit === true to leave in isHidden: { _calculate ...} props
    return flattenApplicationFields(getApplicationFields(ion)).filter((field) => !(field.uiDisplay.isHidden === true));
};
export default getFields;
